/* eslint-disable prettier/prettier */
import { FaMinus, FaPlus } from 'react-icons/fa6';
import { Button } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import ReactInput from '../../../InputList/ReactInput/ReactInput';
import ReactDataTable from '../../../ReactDataTable/ReactDataTable';

const IncludedForm = ({ remove, add }) => {
    const { values } = useFormikContext();
    const column = [
        // {
        //     name: 'Features Name',
        //     cell: (_, i) => <ReactInput name={`features[${i}].name`} />,
        // },
        {
            name: 'Value',
            cell: (_, i) => <ReactInput name={`included[${i}].value`} />,
        },
        {
            name: <Button onClick={() => add({})}>
                <span style={{
                    fontSize: '14px'
                }}>
                    Action <FaPlus />
                </span>
            </Button>,
            width: '120px',
            // select:
            cell: (_, i) => (
                <div>
                    {i === 0 ? (
                        <Button onClick={() => add({})}>
                            <FaPlus />
                        </Button>
                    ) : (
                        <Button onClick={() => remove()}>
                            <FaMinus />
                        </Button>
                    )}
                </div>
            ),
        },
    ];
    // Log
    console.log('values.included =>', values.included);
    return (
        <div>
            <ReactDataTable columns={column} data={values.included} pagination={false} />
        </div>
    );
};
export default IncludedForm;
